/**
 * Copyright 2023-2025 Nordcloud Oy or its affiliates. All Rights Reserved.
 */

export const awsRegions = [
  "ap-south-2",
  "ap-south-1",
  "eu-south-1",
  "eu-south-2",
  "me-central-1",
  "il-central-1",
  "ca-central-1",
  "ap-east-2",
  "mx-central-1",
  "eu-central-1",
  "eu-central-2",
  "us-west-1",
  "us-west-2",
  "af-south-1",
  "eu-north-1",
  "eu-west-3",
  "eu-west-2",
  "eu-west-1",
  "ap-northeast-3",
  "ap-northeast-2",
  "me-south-1",
  "ap-northeast-1",
  "sa-east-1",
  "ap-east-1",
  "ca-west-1",
  "ap-southeast-1",
  "ap-southeast-2",
  "ap-southeast-3",
  "ap-southeast-4",
  "us-east-1",
  "ap-southeast-5",
  "us-east-2",
  "ap-southeast-6",
  "ap-southeast-7",
];
export const awsRegionsOptions = awsRegions.map((region) => ({
  value: region,
  label: region,
}));
